import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";


/*
import translationRU from "./../assets/lang/ru.json";
import translationEN from "./../assets/lang/en.json";
import translationRO from "./../assets/lang/ro.json";
import translationFR from "./../assets/lang/fr.json";

const resources = {
  RU: {
    translation: translationRU,
    name: "Русский",
    iso6391: "RU",
  },
  EN: {
    translation: translationEN,
    name: "English",
    iso6391: "EN",
  },
  RO: {
    translation: translationRO,
    name: "Romanian",
    iso6391: "RO",
  },
  FR: {
    translation: translationFR,
    name: "France",
    iso6391: "FR",
  },
};*/

const backendOptions = {
  loadPath: '/assets/lang/{{lng}}.json',
};

i18next
  .use(Backend)
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    backend: backendOptions,
    load: "languageOnly",
    fallbackLng: "en",
    /*resources: resources,*/
    debug: process.env.REACT_APP_DEBUG, 
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      order: [
        'localStorage',
        'cookie',
        'path',
        'querystring',
        'navigator',
        'header', 
        'session'
    ],
      lookupFromPathIndex: 0, // Индекс части пути для определения языка (например, 0 для /ru/ вместо /ru-ru/)
      lookupLocalStorage: 'idexpress.language',
      lookupCookie: 'idexpress_language',
      caches: ['localStorage', 'cookie'],
    },
  },);
